import { Grid } from "@mui/material";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import { CModalSchemaKeys } from "./BuildingUnitFormModal";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const BuildingUnitCommissions = () => {
  return (
    <Grid container spacing={1} rowGap={2}>
      <Grid item xs={12}>
        <MxFormSubTitle label="Especifica la distribución de comisiones" />
      </Grid>

      <Grid item xs={12} md={6}>
        <MxFormL3TextThousandField
          name={CModalSchemaKeys.totalCommission}
          label="Porcentaje de comisión"
          withreacthookform={1}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MxFormL3TextThousandField
          name={CModalSchemaKeys.commissionGuaranteed}
          label="Porcentaje de comisión agente vendedor"
          withreacthookform={1}
        />
      </Grid>
    </Grid>
  );
};

export default BuildingUnitCommissions;
